export const pt = {
  //languages
  "languages.english": "Inglês (US)",
  "languages.portuguese": "Português (BR)",

  //toggle
  "toggle.theme": "Alternar tema",
  "toggle.language": "Alternar idioma",
  "toggle.menu": "Menu",

  //generic
  "generic.success": "Sucesso",
  "generic.error": "Ocorreu um erro",
  "generic.redirecting": "Redirecionando...",
  "generic.loading": "Carregando...",
  "generic.search": "Pesquisar...",
  "generic.selectAnOption": "Selecione uma opção...",
  "generic.noResultsFound": "Nenhum resultado encontrado.",
  "generic.yourEmail": "seu-email@email.com",
  "generic.cancel": "Cancelar",
  "generic.confirm": "Confirmar",
  "generic.save": "Salvar",
  "generic.register": "Cadastrar",
  "generic.copy": "Copiar",
  "generic.or": "Ou",
  "generic.edit": "Editar",
  "generic.delete": "Excluir",
  "generic.import": "Importar",
  "generic.new": "Novo",
  "generic.reset": "Limpar",
  "generic.create": "Criar",
  "generic.close": "Fechar",
  "generic.update": "Atualizar",
  "generic.upload": "Upload",
  "generic.download": "Download",
  "generic.confirmDelete": "Tem certeza que deseja excluir este item?",
  "generic.confirmDeleteDescription":
    "Esta ação não pode ser revertida. Isso irá excluir permanentemente: ",
  "generic.manage": "Gerenciar",
  "generic.logout": "Sair",
  "generic.settings": "Configurações",
  "generic.previous": "Voltar",
  "generic.next": "Próximo",
  "generic.actions": "Ações",
  "generic.goBack": "Voltar",
  "generic.created_at": "Criado em",
  "generic.link_copied": "Link copiado com sucesso",
  "generic.add": "Adicionar",
  "generic.removeLast": "Remover último",
  "generic.deleting": "Excluindo...",
  //components redirect-message
  "components.redirectMessage.redirectIn": "Redirecionando em",
  "components.redirectMessage.seconds": "segundos",

  //components loading
  "components.loading.loading": "Carregando",

  //components date-picker
  "components.date-picker.months.january": "Janeiro",
  "components.date-picker.months.february": "Fevereiro",
  "components.date-picker.months.march": "Março",
  "components.date-picker.months.april": "Abril",
  "components.date-picker.months.may": "Maio",
  "components.date-picker.months.june": "Junho",
  "components.date-picker.months.july": "Julho",
  "components.date-picker.months.august": "Agosto",
  "components.date-picker.months.september": "Setembro",
  "components.date-picker.months.october": "Outubro",
  "components.date-picker.months.november": "Novembro",
  "components.date-picker.months.december": "Dezembro",

  // Auth
  "auth.login": "Entrar",
  "auth.register": "Criar conta",
  "auth.email": "E-mail",
  "auth.password": "Senha",
  "auth.confirmPassword": "Confirmar senha",
  "auth.fullName": "Nome completo",
  "auth.terms": "Aceito os termos de uso",
  "auth.googleLogin": "Entrar com Google",
  "auth.facebookLogin": "Entrar com Facebook",
  "auth.emailLogin": "Entrar com e-mail",
  "auth.enterAccount": "Entre na sua conta para acessar o sistema",
  "auth.forgotPassword": "Esqueceu a senha?",
  "auth.doNotHaveAccount": "Não tem uma conta?",
  "auth.alreadyHaveAccount": "Já tem uma conta?",
  "auth.registerWithEmail": "Ou registre-se com e-mail",
  "auth.createYourAccount": "Crie sua conta para começar a usar o",
  "auth.failedToLoginWithFacebook": "Erro ao fazer login com Facebook",
  "auth.failedToLoginWithGoogle": "Erro ao fazer login com Google",
  "auth.verifyEmailToConfirmAccount":
    "Verifique seu e-mail para confirmar sua conta",
  "auth.registerSuccess": "Registro realizado com sucesso",
  "auth.registerFailed": "Erro ao registrar, por favor tente novamente",
  "auth.loginSuccess": "Login realizado com sucesso",
  "auth.loginFailed": "Erro ao fazer login, por favor tente novamente",
  "auth.confirmAccountSuccess": "Conta confirmada com sucesso",
  "auth.confirmAccountFailed":
    "Erro ao confirmar conta, por favor tente novamente",
  "auth.emailSent": "E-mail enviado",
  "auth.checkEmailToResetPassword":
    "Verifique seu e-mail para redefinir sua senha",
  "auth.emailSentFailed": "Erro ao enviar e-mail",
  "auth.emailSentFailedMessage":
    "Não foi possível enviar o e-mail de redefinição de senha. Por favor, tente novamente mais tarde.",
  "auth.reCaptchaFailed": "Erro ao verificar reCAPTCHA",
  "auth.forgotPasswordDescription":
    "Digite seu e-mail para redefinir sua senha",
  "auth.forgotPasswordSuccess":
    "E-mail de redefinição de senha enviado com sucesso",
  "auth.forgotPasswordFailed": "Erro ao enviar e-mail de redefinição de senha",
  "auth.forgotPasswordFailedMessage":
    "Não foi possível enviar o e-mail de redefinição de senha. Por favor, tente novamente mais tarde.",
  "auth.resetPasswordSuccess": "Sua senha foi redefinida com sucesso.",
  "auth.resetPasswordError":
    "Erro ao redefinir a senha, token expirado, tente usar a recuperação de senha novamente.",
  "auth.resetPassword": "Redefinir senha",
  "auth.resetPasswordDescription":
    "Crie uma nova senha para acessar o dashboard",
  "auth.twoFactor": "Autenticação de Dois Fatores",
  "auth.twoFactorDescriptionEmail":
    "Enviamos um código de verificação para o seu e-mail",
  "auth.twoFactorDescriptionApp":
    "Insira o código de verificação do seu aplicativo autenticador",

  // Dashboard
  "dashboard.home": "Início",
  "dashboard.title": "Dashboard",
  "dashboard.tabs.all": "Todos",
  "dashboard.empty.noProductTypesTitle": "Nenhum produto configurado",
  "dashboard.empty.noProductTypesHint":
    "Este parceiro ainda não possui produtos vinculados aos projetos. Os indicadores aparecerão quando houver produtos e vendas.",
  "dashboard.platform": "Plataformas",
  "dashboard.insuranceCompanies": "Fornecedores",
  "dashboard.paymentGateways": "Gateways de pagamento",
  "dashboard.users": "Cadastro de Usuários",
  "dashboard.products": "Produtos",
  "dashboard.advertisers": "Campanhas",
  "dashboard.invoices": "Faturas",
  "dashboard.clients": "Parceiros",
  "dashboard.clients.sub.list": "Lista de parceiros",
  "dashboard.clients.sub.detail": "Detalhe do parceiro",
  "dashboard.clients.sub.subPartnersList": "Listar parceiros",
  "dashboard.clients.sub.linkUsers": "Vincular usuários",
  "dashboard.clients.sub.projects": "Projetos",
  "dashboard.clients.sub.campaigns": "Campanhas",
  "dashboard.clients.sub.whatsapp": "Conversas WhatsApp",
  "dashboard.clients.myPartner": "Meu parceiro",

  "partnerSelect.title": "Selecionar parceiro",
  "partnerSelect.description":
    "Escolha o parceiro para continuar. Você será redirecionado para a área solicitada.",
  "partnerSelect.loading": "Carregando parceiros…",
  "partnerSelect.error": "Não foi possível carregar os parceiros.",
  "partnerSelect.empty": "Nenhum parceiro encontrado.",
  "partnerSelect.choose": "Continuar",
  "partnerWhatsappInbox.title": "Conversas WhatsApp",
  "partnerWhatsappInbox.subtitle":
    "Acompanhe em tempo real as mensagens dos leads com o bot (somente leitura).",
  "partnerWhatsappInbox.header.live": "Ao vivo",
  "partnerWhatsappInbox.meta.title": "Integrações Meta",
  "partnerWhatsappInbox.meta.new": "Nova",
  "partnerWhatsappInbox.meta.emptyTitle": "Sem integração",
  "partnerWhatsappInbox.meta.empty":
    "Nenhuma conexão WhatsApp. Crie uma integração Meta para receber mensagens.",
  "partnerWhatsappInbox.meta.open": "Abrir",
  "partnerWhatsappInbox.meta.fromParentOrg": "Matriz",
  "partnerWhatsappInbox.meta.integrationOne": "integração",
  "partnerWhatsappInbox.meta.integrationMany": "integrações",
  "partnerWhatsappInbox.threads.title": "Conversas",
  "partnerWhatsappInbox.threads.search": "Buscar por nome ou telefone",
  "partnerWhatsappInbox.threads.emptyTitle": "Nenhuma conversa",
  "partnerWhatsappInbox.threads.empty":
    "Quando um lead enviar mensagem ao WABA do parceiro, a conversa aparecerá aqui.",
  "partnerWhatsappInbox.messages.selectThreadTitle": "Escolha uma conversa",
  "partnerWhatsappInbox.messages.selectThread":
    "Selecione um contato na lista ao lado para ver o histórico de mensagens.",
  "partnerWhatsappInbox.messages.readOnlyBadge": "Somente leitura",
  "partnerWhatsappInbox.messages.readOnlyHint":
    "Visualização somente leitura. O bot responde via Agno/infinity-agent.",
  "partnerWhatsappInbox.messages.empty": "Sem mensagens nesta conversa.",
  "partnerWhatsappInbox.source.lead": "Lead",
  "partnerWhatsappInbox.source.bot": "Bot",
  "partnerWhatsappInbox.source.template": "Template",
  "partnerWhatsappInbox.source.system": "Sistema",
  "partnerWhatsappInbox.actions.openInbox": "Conversas WhatsApp",
  "partnerWhatsappInbox.actions.metaConfig": "Configuração META",
  "dashboard.campaigns": "Campanhas",
  "dashboard.whatsappMeta": "WhatsApp (Meta)",
  "dashboard.reports": "Relatórios",
  "dashboard.settings": "Configurações",

  //dashboard advertisers
  "dashboard.advertisers.activeCampaign": "Vendas do mês",
  "dashboard.advertisers.pendingCampaign": "Ticket Médio",
  "dashboard.advertisers.finishedCampaign": "Taxa de conversão",
  "dashboard.advertisers.rejectedCampaign": "Receita",
  "dashboard.advertisers.fullImpact": "Impacto Total",

  //validation messages
  "validationMessages.invalidId": "Id inválido",
  "validationMessages.invalidEmail": "Email inválido",
  "validationMessages.numericMessage": "O valor informado deve ser numérico",
  "validationMessages.minLengthMessage": "A quantidade mínima de caracteres é ",
  "validationMessages.maxLengthMessage": "A quantidade máxima de caracteres é ",
  "validationMessages.minValueMessage": "O valor mínimo deve ser ",
  "validationMessages.positiveValueMessage": "O valor deve ser positivo",
  "validationMessages.invalidDateMessage": "Data inválida",
  "validationMessages.enumMessage": "Selecione uma opção",
  "validationMessages.requiredMessage": "Campo Obrigatório",
  "validationMessages.passwordRuleMessage":
    "A senha deve conter pelo menos uma letra, um número e um caractere especial",
  "validationMessages.equalPasswordMessage": "As senhas devem coincidir",
  "validationMessages.acceptTermsMessage": "Você deve aceitar os termos de uso",
  "validationMessages.invalidOptionMessage": "Selecione uma opção",
  "validationMessages.invalidCPF": "CPF inválido",
  "validationMessages.invalidCNPJ": "CNPJ inválido",
  "validationMessages.selectPartnerType": "Você deve selecionar um tipo de parceiro",
  "validationMessages.selectBusinessClassification": "Você deve selecionar uma classificação de empresa",
  "validationMessages.selectCompanyLogo": "Você deve selecionar uma logo para a empresa",
  "validationMessages.selectCnpjCard": "Você deve selecionar um documento de CNPJ",
  "validationMessages.selectContractDocument": "Você deve selecionar um documento de contrato",
  "validationMessages.selectAtLeastOneContract": "Você deve selecionar pelo menos um contrato assinado",

  //settings
  "settings.title": "Configurações",
  "settings.description": "Gerencie suas configurações de conta e preferências",

  "settings.menu.profile": "Perfil e Segurança",
  "settings.menu.billing": "Plano e Faturamento",

  "settings.profile.title": "Informações Pessoais",
  "settings.profileUpdated": "Perfil atualizado com sucesso",
  "settings.profile.fullName": "Nome completo",
  "settings.profile.securityTitle": "Segurança da conta",
  "settings.profile.mfaTitle": "Autenticação de Dois Fatores",
  "settings.profile.mfaDescription":
    "Adicione uma camada extra de segurança à sua conta",
  "settings.profile.mfaMethod": "Método de autenticação",
  "settings.profile.mfaMethodDescription":
    "Escolha como deseja receber os códigos de verificação",
  "settings.profile.mfaMethodApp": "Aplicativo autenticador",
  "settings.profile.mfaSecretCopied": "Código secreto copiado com sucesso",
  "settings.profile.enableMfa": "Habilitar autenticação de dois fatores",
  "settings.profile.scanQrCodeOrCopySecret":
    "Escaneie o QR Code com o aplicativo autenticador ou copie o código secreto",
  "settings.profile.mfaKeyReminder":
    "Certifique-se de validar seu OTP usando as chaves acima",
  "settings.profile.personType": "Tipo de pessoa",
  "settings.profile.personTypeCompany": "Pessoa Jurídica",
  "settings.profile.personTypePerson": "Pessoa Física",
  "settings.security.passwordManagement": "Gerenciamento de senha",
  "settings.security.title": "Segurança da conta",
  "settings.security.changePassword": "Atualizar senha",
  "settings.security.currentPassword": "Senha atual",
  "settings.security.newPassword": "Nova senha",
  "settings.security.confirmNewPassword": "Confirmar nova senha",
  "settings.security.passwordUpdated": "Senha atualizada com sucesso",

  //clients
  "clients.title": "Parceiros",
  "clients.subtitle.partnerPlans": "Planos do Parceiro",
  "clients.description": "Gerencie seus Parceiros",
  "clients.plan-form.soulhubSingleProduct":
    "Produto único no SoulHub",
  "clients.plan-form.soulhubSingleProductHint":
    "Sincroniza este combo como um único produto no SoulHub: nome do plano, descrições reunidas e preço do plano (plan_price).",
  "clients.plan-form.soulhubAnchorProduct":
    "Produto base (âncora) para tipo e códigos",
  "clients.plan-form.soulhubAnchorProductHint":
    "Opcional. Se definido, este produto será usado como base para tipo e códigos no sync do plano→produto.",
  "clients.form.create.title": "Criar Parceiro",
  "clients.form.create.description":
    "Crie um novo Parceiro para começar a usar",
  "clients.form.edit.title": "Editar Parceiro",
  "clients.form.edit.description": "Edite as informações do Parceiro",
  "clients.form.fields.name": "Nome fantasia",
  "clients.form.fields.cnpj": "CNPJ",
  "clients.form.fields.corporate_name": "Razão social",
  "clients.form.fields.type.partner": "Tipo de Parceiro",
  "clients.form.fields.type.partner.client": "Cliente",
  "clients.form.fields.type.partner.businessIndicator":
    "Indicador de negócio - Hunter",
  "clients.form.fields.provider": "Provedor de IA",
  "clients.form.fields.aiModel": "Modelo de IA",
  "clients.form.fields.hasTokenLimit": "Tem limite de tokens",
  "clients.form.fields.tokenLimit": "Limite de tokens",
  "clients.form.descriptions.hasTokenLimit":
    "Quando o limite de tokens é atingido, o Parceiro parará de funcionar até que o limite seja resetado",
  "clients.name": "Nome",
  "clients.cnpj": "CNPJ",
  "clients.corporate_name": "Razão social",
  "clients.status": "Status",
  "clients.status.pending_data": "Pendente de dados",
  "clients.status.pending_review": "Pendente de revisão",
  "clients.status.approved": "Aprovado",
  "clients.status.rejected": "Rejeitado",
  "clients.status.pending_data.description":
    "O Parceiro ainda não preencheu todos os dados necessários",
  "clients.status.pending_review.description":
    "O Parceiro ainda não foi revisado pela equipe",
  "clients.status.approved.description": "O Parceiro foi aprovado",
  "clients.status.rejected.description": "O Parceiro foi rejeitado",
  "clients.noClients": "Nenhum Parceiro encontrado",
  "clients.knowledgeImport": "Importar Conhecimento",
  "clients.knowledgeBase": "Base de Conhecimento",
  "clients.actions.copyApiKey": "Copiar API key",
  "clients.success.apiKeyCopied": "API key copiada com sucesso",
  "clients.success.partnerDeleted": "Parceiro deletado com sucesso",
  "clients.success.partnerUpdated": "Parceiro atualizado com sucesso",
  "clients.success.partnerCreated": "Parceiro criado com sucesso",
  "clients.success.partnerApproved": "Parceiro aprovado com sucesso",
  "clients.success.partnerRejected": "Parceiro rejeitado com sucesso",
  "clients.success.clientCreated": "Cadastro realizado com sucesso!",
  "clients.success.clientUpdated": "Dados atualizados com sucesso!",
  "clients.success.modalTitle": "Cadastro Concluído!",
  "clients.success.modalDescription":
    "Seu cadastro foi enviado com sucesso. Nossa equipe entrará em contato em breve para finalizar o processo.",
  "clients.success.goToLogin": "Ir para Login",
  "clients.errors.approveFailed": "Erro ao aprovar Parceiro",
  "clients.errors.rejectFailed": "Erro ao rejeitar Parceiro",
  "clients.errors.createFailed": "Erro ao criar cadastro",
  "clients.errors.updateFailed": "Erro ao atualizar dados",
  "clients.review.title": "Revisão de Dados do Parceiro",
  "clients.review.description":
    "Revise os dados da empresa antes de aprovar ou rejeitar",
  "clients.review.basicInfo": "Informações Básicas",
  "clients.review.address": "Endereço",
  "clients.review.representative": "Representante da Empresa",
  "clients.review.bankAccount": "Conta Bancária",
  "clients.review.pixKey": "Chave PIX",
  "clients.review.documents": "Documentos",
  "clients.review.terms": "Termos e Condições",
  "clients.review.rejectionModal.title": "Motivo da Rejeição",
  "clients.review.rejectionModal.reason": "Motivo da rejeição",
  "clients.review.rejectionModal.placeholder":
    "Descreva o motivo pelo qual a empresa está sendo rejeitada...",
  "clients.review.rejectionModal.confirm": "Confirmar Rejeição",
  "clients.review.actions.approve": "Aprovar Empresa",
  "clients.review.actions.reject": "Rejeitar Dados",
  "clients.review.actions.cancel": "Cancelar",
  "clients.review.view": "Visualizar Dados",
  "clients.review.loading": "Carregando dados do Parceiro...",
  "clients.review.notInformed": "Não informado",
  "clients.review.sent": "Enviado",
  "clients.review.notSent": "Não enviado",
  "clients.review.yes": "Sim",
  "clients.review.no": "Não",
  "clients.partnerPortal.title": "Acesso ao portal do parceiro",
  "clients.partnerPortal.description":
    "Crie o login master desta organização (e-mail e senha).",
  "clients.partnerPortal.email": "E-mail",
  "clients.partnerPortal.password": "Senha",
  "clients.partnerPortal.confirmPassword": "Confirmar senha",
  "clients.partnerPortal.useRepresentative": "Usar dados do representante",
  "clients.partnerPortal.manualSection": "Perfil do usuário (manual)",
  "clients.partnerPortal.submit": "Criar acesso ao portal",
  "clients.partnerPortal.masterExists":
    "Já existe um usuário master para este parceiro.",
  "clients.partnerPortal.createSuccess": "Acesso ao portal criado com sucesso.",
  "clients.partnerPortal.createError": "Não foi possível criar o acesso ao portal.",
  "clients.partnerPortal.manualRequired":
    "Preencha o perfil manual ou marque dados do representante.",
  "clients.review.openDocument": "Abrir documento",
  "clients.tax_classification.simples_nacional": "Simples Nacional",
  "clients.tax_classification.lucro_presumido": "Lucro Presumido",
  "clients.tax_classification.lucro_real": "Lucro Real",
  "clients.tax_classification.not_informed": "Não informado",
  "clients.business_classification.servicos": "Serviços",
  "clients.business_classification.industria": "Indústria",
  "clients.business_classification.comercial": "Comercial",
  "clients.business_classification.agricultura": "Agricultura",
  "clients.business_classification.outros": "Outros",
  "clients.business_classification.not_informed": "Não informado",
  "clients.created_at": "Criado em",
  "clients.success.planCreated": "Plano criado com sucesso",
  "clients.success.planUpdated": "Plano atualizado com sucesso",
  "clients.success.planSaved": "Plano salvo com sucesso",
  "clients.success.planDeleted": "Plano deletado com sucesso",
  "plansForm.sameGatewayHint":
    "Cada plano só pode reunir produtos com o mesmo gateway de pagamento. Depois que você escolher o primeiro produto (faixa de capital), a lista fica restrita a esse gateway.",
  "plansForm.sameGatewayFilterActive":
    "Exibindo apenas produtos com o mesmo gateway de pagamento do primeiro item selecionado:",
  "plansForm.gatewayMismatchToast":
    "Este produto usa outro gateway de pagamento. Todos os produtos de um mesmo plano devem usar o mesmo gateway.",
  "plansForm.emptySearch": "Nenhum produto encontrado com esse nome.",
  "plansForm.emptyNoProducts": "Nenhum produto disponível.",
  "plansForm.emptyFilteredByGateway":
    "Nenhum produto combina com a busca e com o gateway já escolhido para este plano. Limpe a seleção ou ajuste a busca.",
  "clients.partner": "Parceiro",
  "clients.form.fields.prompt": "Prompt",
  "clients.form.placeholders.name": "Digite o nome do parceiro",
  "clients.form.placeholders.prompt": "Digite o prompt",
  "clients.form.placeholders.provider": "Selecione o provedor",
  "clients.form.placeholders.tokenLimit": "Digite o limite de tokens",

  //clients register page
  "clients.register.title": "Cadastro de Organização",
  "clients.register.description": "Preencha os dados abaixo para realizar o cadastro da sua organização",
  "clients.register.submit": "Cadastrar",
  "clients.register.submitting": "Cadastrando...",
  "clients.register.terms.accept": "Aceito os",
  "clients.register.terms.link": "Termos de Uso",
  "clients.register.searchExistingOrganization": "Buscar organização existente por CNPJ",
  "clients.register.organizationFound": "Organização já cadastrada",
  "clients.register.associateToProject": "Cadastrar a novo projeto",
  "clients.register.organizationAssociated": "Organização associada ao projeto com sucesso!",
  "clients.register.errorAssociating": "Erro ao associar organização ao projeto",

  //clients form sections
  "clients.form.sections.companyData": "Dados da Empresa",
  "clients.form.sections.address": "Endereço",
  "clients.form.sections.companyRepresentative": "Representante da Empresa",
  "clients.form.sections.representative": "Representante da Empresa",
  "clients.form.sections.representative.description": "Dados do representante legal da empresa",
  "clients.form.sections.bankData": "Dados Bancários",
  "clients.form.sections.bankAccount": "Dados Bancários",
  "clients.form.sections.documents": "Documentos",

  //clients form fields
  "clients.form.fields.email": "E-mail",
  "clients.form.fields.business_classification": "Classificação de Negócio",
  "clients.form.fields.postal_code": "CEP",
  "clients.form.fields.street": "Rua",
  "clients.form.fields.number": "Número",
  "clients.form.fields.complement": "Complemento",
  "clients.form.fields.neighborhood": "Bairro",
  "clients.form.fields.city": "Cidade",
  "clients.form.fields.state": "Estado",
  "clients.form.fields.first_name": "Primeiro Nome",
  "clients.form.fields.last_name": "Sobrenome",
  "clients.form.fields.personal_email": "E-mail Pessoal",
  "clients.form.fields.cpf": "CPF",
  "clients.form.fields.mobile_phone": "Telefone Celular",
  "clients.form.fields.bank_name": "Nome do Banco",
  "clients.form.fields.bank_branch": "Agência",
  "clients.form.fields.checking_account": "Conta Corrente",
  "clients.form.fields.checking_account_digit": "Dígito da Conta",
  "clients.form.fields.pix_key": "Chave PIX",
  "clients.form.placeholders.pix_key":
    "CPF, CNPJ, e-mail, telefone ou chave aleatória (opcional)",
  "clients.form.fields.company_logo": "Logo da Empresa",
  "clients.form.fields.company_logo_description": "Envie a logo da sua empresa (JPG, PNG ou PDF - máx 5MB)",
  "clients.form.fields.cnpj_card": "Cartão CNPJ",
  "clients.form.fields.cnpj_card_description": "Envie o cartão CNPJ da empresa (JPG, PNG ou PDF - máx 5MB)",
  "clients.form.fields.partners_documents_cpf": "CPF dos Sócios",
  "clients.form.fields.partners_documents_cpf_description": "Envie os documentos de CPF dos sócios (JPG, PNG ou PDF - máx 5MB cada, até 4 arquivos)",
  "clients.form.fields.articles_of_incorporation": "Contrato Social",
  "clients.form.fields.articles_of_incorporation_description": "Envie o contrato social da empresa (PDF - máx 5MB)",
  "clients.form.fields.signed_contract": "Contrato Assinado",
  "clients.form.fields.signed_contract_description": "Envie o contrato assinado (JPG, PNG ou PDF - máx 5MB cada, até 4 arquivos)",
  //users
  "users.title": "Usuários",
  "users.subtitle": "Cadastro de Usuários",
  "users.description": "Gerencie seus usuários",
  "users.form.create.title": "Criar usuário",
  "users.form.create.description": "Crie um novo usuário para começar a usar",
  "users.form.edit.title": "Editar usuário",
  "users.form.edit.description": "Edite as informações do usuário",

  //advertisers
  "advertisers.title": "Anunciantes",
  "advertisers.description": "Gerencie seus anunciantes",

  //invoices
  "invoices.title": "Faturas",
  "invoices.description": "Gerencie suas faturas",

  //platforms
  "platform.title": "Minhas plataformas",
  "platform.description": "Gerencie suas plataformas",
  "platform.form.fields.name": "Nome da empresa",
  "platform.form.fields.cnpj": "CNPJ",
  "platform.form.fields.namePlatform": "Nome da plataforma",
  "platform.form.placeholders.name": "Digite o nome da plataforma",
  "platform.form.placeholders.cnpj": "Digite o CNPJ da plataforma",
  "platform.form.placeholders.namePlatform": "Digite o nome da plataforma",
  "platforms.plataform.form.noProductsInCombo":
    "Nenhum produto selecionado para este combo.",
  "platforms.plataform.form.comboName": "Nome do plano",
  "platforms.plataform.form.comboDescription": "Descrição do plano",
  "platforms.plataform.form.comboPrice": "Preço do plano",
  "platforms.plataform.form.comboProducts": "Produtos do plano",

  // payment gateways
  "paymentGateways.title": "Gateways de pagamento",
  "paymentGateways.description":
    "Cadastre gateways de uso nos produtos (Soulhub, Infinity/sync, parceiros). Chaves privadas ficam apenas no deploy (variáveis PAYMENT_GATEWAY_{SLUG}_* na API e na LP), não neste formulário.",
  "paymentGateways.button.new": "Novo gateway",
  "paymentGateways.table.slug": "Slug",
  "paymentGateways.table.name": "Nome",
  "paymentGateways.table.active": "Ativo",
  "paymentGateways.table.actions": "Ações",
  "paymentGateways.status.active": "Sim",
  "paymentGateways.status.inactive": "Não",
  "paymentGateways.form.slug": "Slug",
  "paymentGateways.form.name": "Nome",
  "paymentGateways.form.description": "Descrição",
  "paymentGateways.form.active": "Ativo",
  "paymentGateways.dialog.createTitle": "Novo gateway",
  "paymentGateways.dialog.editTitle": "Editar gateway",
  "paymentGateways.delete.title": "Excluir gateway",
  "paymentGateways.delete.description":
    "Tem certeza que deseja excluir este gateway?",
  "paymentGateways.success.created": "Gateway criado.",
  "paymentGateways.success.updated": "Gateway atualizado.",
  "paymentGateways.success.deleted": "Gateway removido.",

  //insurance companies
  "insuranceCompanies.title": "Fornecedores",
  "insuranceCompanies.description": "Gerencie seus fornecedores",
  "insuranceCompanies.form.fields.name": "Nome da empresa",
  "insuranceCompanies.form.fields.corporateName": "Nome corporativo",
  "insuranceCompanies.form.fields.cnpj": "CNPJ",
  "insuranceCompanies.no_insurance_companies": "Nenhum fornecedor encontrado",
  "insuranceCompanies.name": "Nome",
  "insuranceCompanies.cnpj": "CNPJ",
  "insuranceCompanies.corporate_name": "Razão social",
  "insuranceCompanies.created_at": "Criado em",
  "insuranceCompanies.type": "Tipo",
  "insuranceCompanies.form.fields.type": "Tipo de empresa",
  "insuranceCompanies.form.fields.type.insurance": "Seguradora",
  "insuranceCompanies.form.fields.type.guarantor": "Garantidora",
  "insuranceCompanies.success.insuranceCompanyDeleted":
    "Fornecedor deletado com sucesso",
  "insuranceCompanies.success.insuranceCompanyUpdated":
    "Fornecedor atualizado com sucesso",
  "insuranceCompanies.success.insuranceCompanyCreated":
    "Fornecedor criado com sucesso",
  //products
  "products.title": "Produtos",
  "products.description": "Gerencie seus produtos",
  "products.button.new.combo": "Novo combo",
  "products.button.new.product": "Novo produto",
  "products.success.productCreated": "Produto criado com sucesso",
  "products.success.productUpdated": "Produto atualizado com sucesso",
  "products.success.productDeleted": "Produto deletado com sucesso",
  "products.button.create": "Cadastrar Produto",
  "products.button.update": "Atualizar Produto",
  "products.journey.tabTitle": "Jornada de cotação (LP)",
  "products.journey.tabShort": "Jornada",
  "products.journey.tabDescription":
    "Defina campos e etapas coletados na landing antes do checkout. Salve o produto primeiro e depois salve a jornada.",
  "products.journey.needProductSaved":
    "Salve o produto para habilitar a configuração da jornada.",
  "products.journey.loadError": "Não foi possível carregar a jornada.",
  "products.journey.saveSuccess": "Jornada salva com sucesso.",
  "products.journey.saveError": "Não foi possível salvar a jornada.",
  "products.journey.duplicateField": "Este campo já está na jornada.",
  "products.journey.defaultStepTitle": "Etapa 1",
  "products.journey.presetsTitle": "Campos padrão (clique para adicionar)",
  "products.journey.fieldsTitle": "Campos configurados",
  "products.journey.noFieldsYet": "Nenhum campo. Use os presets acima.",
  "products.journey.fieldKey": "Chave",
  "products.journey.fieldLabel": "Rótulo",
  "products.journey.fieldWidget": "Tipo do campo",
  "products.journey.widget.text": "Texto em uma linha",
  "products.journey.widget.textarea": "Texto em várias linhas",
  "products.journey.widget.email": "E-mail",
  "products.journey.widget.tel": "Telefone",
  "products.journey.widget.number": "Número",
  "products.journey.widget.currency": "Valor em dinheiro (R$)",
  "products.journey.widget.date": "Data (calendário)",
  "products.journey.widget.select": "Lista suspensa (uma opção)",
  "products.journey.widget.combobox": "Lista com busca",
  "products.journey.widget.checkbox": "Caixa de marcação",
  "products.journey.widget.switch": "Ligar / desligar",
  "products.journey.fieldRequired": "Obrigatório",
  "products.journey.fieldFillable": "Preenchível na LP",
  "products.journey.fieldPlaceholder": "Placeholder",
  "products.journey.fieldPlaceholderHint": "Texto de exemplo no campo",
  "products.journey.fieldHelpText": "Texto de ajuda",
  "products.journey.fieldDefaultValue": "Valor padrão",
  "products.journey.fieldIntegrationType": "Tipo de integração",
  "products.journey.fieldIntegrationTypeHint": "ex.: person_full_name",
  "products.journey.fieldOptions": "Opções (lista/select)",
  "products.journey.addOption": "Adicionar opção",
  "products.journey.noOptionsYet": "Nenhuma opção. Adicione valor e rótulo.",
  "products.journey.optionValue": "Valor",
  "products.journey.optionLabel": "Rótulo exibido",
  "products.journey.addCustomField": "Campo personalizado",
  "products.journey.customFieldDefaultLabel": "Campo personalizado",
  "products.journey.invalidFieldKey":
    "Chave inválida. Use snake_case (ex.: meu_campo).",
  "products.journey.fieldStep": "Etapa",
  "products.journey.pickStep": "Selecione a etapa",
  "products.journey.step": "Etapa",
  "products.journey.stepsTitle": "Etapas",
  "products.journey.addStep": "Adicionar etapa",
  "products.journey.noStepsHint":
    "As etapas são criadas ao adicionar campos ou use Adicionar etapa.",
  "products.journey.stepTitle": "Título da etapa",
  "products.journey.stepTitlePlaceholder": "ex.: Dados pessoais",
  "products.journey.stepOrder": "Ordem",
  "products.journey.stepFieldKeys": "Chaves de campo nesta etapa",
  "products.journey.saveButton": "Salvar jornada",
  "products.journey.preset.client_full_name.label": "Nome completo",
  "products.journey.preset.client_email.label": "E-mail",
  "products.journey.preset.client_phone.label": "Telefone",
  "products.journey.preset.client_cpf.label": "CPF",
  "products.journey.preset.birth_date.label": "Data de nascimento",
  "products.journey.preset.requested_amount.label": "Valor solicitado",
  "products.journey.preset.loan_term_months.label": "Prazo (meses)",
  "products.journey.preset.vehicle_plate.label": "Placa",
  "products.journey.preset.vehicle_chassis.label": "Chassi",
  "products.journey.preset.vehicle_model_year.label": "Ano do modelo",
  "products.journey.preset.annual_mileage_km.label": "Km rodados/ano",
  "products.journey.preset.home_city.label": "Cidade",
  "products.journey.preset.quotation_notes.label": "Observações",
  "products.journey.preset.client_rg.label": "RG",
  "products.journey.preset.home_state.label": "Estado (UF)",
  "products.journey.preset.home_zip.label": "CEP",
  "products.journey.preset.occupation.label": "Profissão",
  "products.journey.preset.monthly_income.label": "Renda mensal",
  "products.journey.preset.vehicle_brand.label": "Marca do veículo",
  "products.journey.preset.vehicle_model.label": "Modelo do veículo",
  "products.journey.preset.vehicle_color.label": "Cor do veículo",
  "products.journey.preset.device_serial.label": "Nº de série / IMEI",
  "products.journey.preset.insured_item_description.label": "Descrição do bem",
  "products.journey.preset.desired_coverage_amount.label": "Valor de cobertura desejado",
  "products.journey.preset.policy_start_date.label": "Início da vigência",
  "products.journey.preset.pet_name.label": "Nome do pet",
  "products.journey.preset.pet_species.label": "Espécie do pet",
  "products.journey.preset.pet_breed.label": "Raça do pet",
  "products.journey.preset.pet_size.label": "Porte do pet",
  "products.journey.preset.pet_age.label": "Idade do pet",
  "products.journey.preset.pet_registration_code.label": "Registro do pet",
  "products.catalog.popover.title": "Tipo de produto",
  "products.catalog.popover.description":
    "Escolha o tipo de produto que deseja criar.",
  "products.catalog.coming_soon.title": "Em breve",
  "products.catalog.coming_soon.description":
    "Este cadastro estará disponível em breve.",
  "products.catalog.future.machinery_equipment_insurance":
    "Seguro Máquinas e Equipamentos",
  "products.catalog.future.heavy_vehicles_insurance":
    "Seguros Pesados (caminhões e ônibus)",
  "products.catalog.future.property_insurance": "Seguros Patrimoniais",
  "products.catalog.future.grain_crop_insurance":
    "Seguros Cultura de Grãos",
  "products.catalog.future.pme_insurance": "Seguros PME",
  "products.catalog.future.civil_liability_insurance":
    "Seguros Responsabilidade Cível",
  "products.catalog.future.do_insurance": "Seguros D&O",
  "products.catalog.future.risks_insurance": "Seguros de Riscos",
  "products.catalog.future.travel_insurance": "Seguros Viagem",
  "products.catalog.future.mobile_insurance": "Seguros Celular",
  "products.catalog.future.credit_line_insurance": "Seguros de Crédito",

  "products.credit.sectionTitle": "Produto de crédito",
  "products.credit.configTitle": "Configuração de crédito",
  "products.credit.infinitySync": "Infinity como origem do sync",
  "products.credit.validation.maxReleasedGteMin":
    "O valor máximo liberado deve ser maior ou igual ao mínimo",
  "products.credit.validation.maxAgeGteMin":
    "A idade máxima deve ser maior ou igual à mínima",
  "products.credit.modality.consignado": "Consignado",
  "products.credit.modality.pessoal": "Pessoal",
  "products.credit.modality.flexpay": "Flexpay (cartão)",
  "products.credit.modality.fgts_antecipacao": "Antecipação FGTS",
  "products.credit.modality.private_label": "Private label (cartão)",
  "products.credit.modality.home_equity": "Home equity",
  "products.credit.modality.auto_equity": "Auto equity",
  "products.credit.modality.financiamento_veiculo": "Financiamento automóvel",
  "products.credit.modality.agricola": "Agrícola",
  "products.credit.consignado.publico": "Setor público",
  "products.credit.consignado.privado": "Setor privado",
  "products.credit.interest.with_insurance": "Com seguro",
  "products.credit.interest.without_insurance": "Sem seguro",
  "products.credit.days.business": "Dias úteis",
  "products.credit.days.calendar": "Dias corridos",
  "products.credit.days.within_1h": "Até 1h",
  "products.credit.days.immediate": "Imediato",
  "products.credit.remuneration.percent_on_released": "% sobre crédito liberado",
  "products.credit.remuneration.fixed_per_released": "$ por crédito liberado",
  "products.credit.remuneration.fixed_per_lead": "$ por lead",
  "products.credit.target.individual": "Pessoa física",
  "products.credit.target.company": "Pessoa jurídica",
  "products.credit.fields.modality": "Modalidade de crédito",
  "products.credit.fields.consignado_scope": "Consignado — âmbito",
  "products.credit.fields.public_sector_category": "Categoria setor público",
  "products.credit.fields.interest_rate_basis": "Composição da taxa de juros",
  "products.credit.fields.interest_rate_percent": "Taxa de juros estimada (%)",
  "products.credit.fields.has_value_premise": "Premissa de valores liberados",
  "products.credit.fields.min_released_value": "Valor mínimo liberado",
  "products.credit.fields.max_released_value": "Valor máximo liberado",
  "products.credit.fields.release_deadline_basis": "Prazo estimado de liberação do crédito",
  "products.credit.fields.release_deadline_days": "Prazo de liberação (dias)",
  "products.credit.fields.remuneration_type": "Remuneração sobre produto",
  "products.credit.fields.remuneration_value": "Valor da remuneração",
  "products.credit.fields.allows_negative_credit": "Liberação para negativados",
  "products.credit.fields.estimated_release_basis": "Tempo estimado (base)",
  "products.credit.fields.estimated_release_days": "Tempo estimado (dias)",
  "products.credit.fields.has_age_restriction": "Restrição por idade",
  "products.credit.fields.min_age_years": "Idade mínima (anos)",
  "products.credit.fields.max_age_years": "Idade máxima (anos)",
  "products.credit.fields.target_person_type": "Destino PF ou PJ",
  "products.credit.fields.notes": "Observações",
  "products.credit.tab.financial": "Taxas e valores",
  "products.credit.tab.remuneration": "Prazos e remuneração",
  "products.credit.tab.rules_integration": "Premissas de concessão",

  //products filters
  "products.filters.name": "Nome",
  "products.filters.namePlaceholder": "Buscar por nome…",
  "products.filters.supplier": "Fornecedor",
  "products.filters.type": "Tipo",
  "products.filters.all": "Todos",
  "products.filters.clear": "Limpar filtros",
  "products.filters.typeAssistanceSoulhub": "Assistência - Soulhub",
  "products.filters.typeAssistanceInfinity": "Assistências - Infinity",

  //products table
  "products.table.name": "Nome",
  "products.table.supplier": "Fornecedor",
  "products.table.type": "Tipo",
  "products.table.vigencyType": "Tipo de Vigência",
  "products.table.lastModified": "Última modificação",
  "products.table.actions": "Ações",
  "products.actions.viewDetails": "Ver detalhes",
  "products.actions.edit": "Editar",
  "products.page.viewTitle": "Detalhes do produto",
  "products.page.editTitle": "Editar produto",
  "products.page.viewingLabel": "Produto:",
  "products.page.editingLabel": "Editando:",
  "products.table.expandEmpty":
    "Não há faixas ou valores de precificação para exibir.",
  "products.table.capital": "Capital:",
  "products.table.minimumValue": "Valor mínimo:",
  "products.table.premium": "Prêmio:",
  "products.table.costValue": "Valor de custo:",
  "products.table.netPremium": "Prêmio NET:",
  "products.table.previewName": "Nome:",
  "products.table.previewDescription": "Descrição:",
  "products.table.planName": "Plano:",
  "products.table.planDescription": "Descrição:",
  "products.table.noName": "Sem nome",
  "products.table.noDescription": "Sem descrição",
  "products.table.priceField.net_price": "Preço NET",
  "products.table.priceField.minimum_price": "Preço mínimo",
  "products.table.priceField.maximum_price": "Preço máximo",
  "products.table.priceField.commissioned_price": "Preço comissionado",
  "products.table.priceField.commission_percent": "Comissão (%)",
  "products.table.priceField.net_plus_fixed_fee": "Prêmio (NET) + taxa fixa por venda",
  "products.table.priceField.cost_net_gateway": "Preço de custo (NET + Gateway)",
  "products.table.priceField.sale_price": "Preço de venda",
  "products.table.priceField.sale_price_calculated": "Preço de venda (calculado)",
  "products.table.priceField.net_premium": "Prêmio NET",
  "products.table.priceField.premium_value": "Prêmio",
  "products.table.priceField.capital_value": "Capital",
  "products.table.priceField.practiced_price": "Preço praticado",
  "products.table.priceField.liquid_price": "Preço líquido",
  "products.table.priceField.gross_price": "Preço bruto",
  "products.table.priceField.sale_price_plan": "Preço de venda do plano",
  "products.table.priceField.prefixed_premium": "Prêmio pré-fixado",

  //products tittle tab
  "products.title.tab.data": "Dados",
  "products.title.tab.price": "Preço",
  "products.title.tab.commercialLoading": "Carregamento Comercial",
  "products.title.tab.integration": "Integração",
  "products.title.tab.plans": "Planos",

  "products.auto.quoteNotice":
    "O prêmio e a precificação seguem o fluxo de cotação. Use esta etapa para cadastrar planos, referências e limites acordados com o parceiro.",
  "products.auto.plansEmptyTitle": "Nenhum plano adicionado ainda",
  "products.auto.plansEmptyHint": "Clique no botão abaixo para criar o primeiro plano.",
  "products.auto.addPlan": "Adicionar novo plano",

  "products.auto.fields.insurance_company_id": "Seguradora / Fornecedor",
  "products.auto.fields.policy_number": "N° da apólice",
  "products.auto.fields.policy_start_date": "Data de início da apólice",
  "products.auto.fields.policy_end_date": "Data de fim da apólice",
  "products.auto.fields.cod_sub": "Código Sub.",
  "products.auto.fields.susep_code": "Código processo SUSEP",
  "products.auto.fields.iof_value": "Valor do IOF (%)",
  "products.auto.fields.type_of_vigency": "Tipo de vigência",
  "products.auto.fields.km_max_permitted": "Km máximo permitido",
  "products.auto.fields.min_manufacturing_year": "Ano mínimo de fabricação permitido",
  "products.auto.fields.description": "Descrição",
  "products.auto.fields.coverage": "Cobertura",
  "products.auto.fields.general_conditions": "Condições gerais",

  "products.vehicle.fields.emission_type": "Tipo de emissão",
  "products.vehicle.emission.apolice": "Apólice",
  "products.vehicle.emission.bilhete": "Bilhete",
  "products.vehicle.fields.collective_policy": "Produto de apólice coletiva?",
  "products.vehicle.fields.susep_product_code": "Código produto SUSEP (use NA se não aplicável)",
  "products.vehicle.fields.has_km_limit": "Limites quilometragem?",
  "products.vehicle.fields.has_year_limit": "Limites de ano de fabricação?",
  "products.vehicle.fields.max_vehicle_age": "Idade máxima do veículo (anos)",
  "products.vehicle.fields.premium_mode": "Prêmio",
  "products.vehicle.premium.prefixed": "Pré-fixado",
  "products.vehicle.premium.calculated": "Sob cálculo",
  "products.vehicle.fields.prefixed_premium": "Valor do prêmio (R$)",
  "products.vehicle.fields.has_multiple_plans": "Produto possui outros planos?",
  "products.vehicle.fields.has_estipulante": "Estipulante?",
  "products.vehicle.fields.stipulant_policy_id": "Apólice ID estipulante",
  "products.vehicle.fields.has_sub_estipulante": "Sub-estipulante?",
  "products.vehicle.fields.excluded_risks": "Riscos excluídos",
  "products.vehicle.commercial.commission": "Comissão",
  "products.vehicle.commercial.commission_value": "Valor comissão",
  "products.vehicle.commercial.boxTitle": "Condição comercial",
  "products.vehicle.commercial.valueMode": "Tipo de valor",
  "products.vehicle.commercial.modePercentage": "Percentual (%)",
  "products.vehicle.commercial.modeCurrency": "Valor (R$)",
  "products.vehicle.commercial.commission_percent": "Percentual comissão (%)",
  "products.vehicle.commercial.commission_value_currency": "Valor comissão (R$)",
  "products.vehicle.commercial.pro_labore_percent": "Pró-labore (%)",
  "products.vehicle.commercial.pro_labore_value_currency": "Valor pró-labore (R$)",
  "products.vehicle.commercial.markup_percent": "Markup (%)",
  "products.vehicle.commercial.markupModePercentOnNet":
    "Percentual (%) sobre o preço NET",
  "products.vehicle.commercial.markupModeFixedValue": "Valor fixo (R$)",
  "products.vehicle.commercial.markup_value_currency": "Valor markup (R$)",
  "products.vehicle.commercial.pro_labore": "Pró-labore",
  "products.vehicle.commercial.pro_labore_value": "Valor pró-labore",
  "products.vehicle.commercial.markup": "Markup",
  "products.vehicle.commercial.markup_value": "Valor markup",
  "products.vehicle.plan.new_coverages": "Novas coberturas",
  "products.vehicle.plan.adjustments.sectionTitle": "Ajustes dos planos",
  "products.vehicle.plan.adjustments.sectionHint":
    "Selecione os tipos de ajuste aplicáveis a este plano e preencha os valores quando indicado.",
  "products.vehicle.plan.adjustments.types.lmi":
    "LMI - % sobre Tabela FIPE (limite máximo indenização)",
  "products.vehicle.plan.adjustments.fipeTablePercent": "Percentual tabela FIPE (%)",
  "products.vehicle.plan.adjustments.insuredSumToggle":
    "Nova importância assegurada?",
  "products.vehicle.plan.adjustments.insuredSumValue":
    "Nova importância assegurada (R$)",
  "products.vehicle.plan.adjustments.types.is": "IS (importância segurada)",
  "products.vehicle.plan.adjustments.types.ages": "Idades",
  "products.vehicle.plan.adjustments.types.usage_in_term":
    "Quantidade de utilização na vigência",
  "products.vehicle.plan.adjustments.types.additional_assistance":
    "Assistência adicional",
  "products.vehicle.plan.adjustments.types.custom": "Criar item novo",
  "products.vehicle.plan.adjustments.customLabel": "Nome do item",
  "products.vehicle.plan.adjustments.assistanceDescription":
    "Descrição da assistência adicional",
  "products.vehicle.plan.adjustments.newProductValueToggle":
    "Novo valor do produto?",
  "products.vehicle.plan.adjustments.newProductValue": "Valor (R$)",
  "products.vehicle.plan.adjustments.newCommissionToggle":
    "Novo valor de comissionamento?",
  "products.vehicle.plan.adjustments.newCommissionPercent":
    "Comissionamento (%)",

  //products form tab data
  "products.form.fields.product_type": "Tipo de produto",
  "products.form.fields.product_type.placeholder": "Selecione",
  "products.form.fields.name": "Nome do produto",
  "products.form.fields.external_product_id":
    "ID externo do produto (integração)",
  "products.form.fields.external_product_id_placeholder":
    "Ex.: código no sistema do cliente",
  "products.form.fields.code_product": "Código do produto",
  "products.form.fields.description": "Descrição",
  "products.form.fields.coverage": "Cobertura",
  "products.form.fields.benefits": "Benefícios",
  "products.form.fields.general_conditions": "Condições gerais",
  "products.form.fields.cost_price": "Preço de custo",
  "products.form.fields.final_price": "Preço final",
  "products.form.fields.final_extra_price": "Preço final extra",
  "products.form.fields.insurance_company_id": "Fornecedor",
  "products.form.fields.guarantor": "Fornecedor",
  "products.form.fields.insurance_company_id.placeholder": "Selecione",
  "products.sync.badge": "Sincronizado Infinity",
  "products.sync.sourceOrganizations": "Origem na Infinity",
  "products.sync.sourceOrganizationsHint":
    "Este produto foi espelhado a partir do plano na Infinity das organizações abaixo.",
  "products.form.fields.payment_gateway": "Gateway de pagamento",
  "products.form.fields.payment_gateway_placeholder": "Selecione o gateway",
  "products.form.fields.insurance_policy_id": "ID da apólice",
  "products.form.fields.policy_number": "Número da apólice",
  "products.form.fields.cod_sub": "Código Sub",
  "products.form.fields.susep_code": "Código Processo SUSEP",

  "products.form.fields.table_code": "Código da tabela",
  "products.form.fields.policy_start_date": "Data de início da apólice",
  "products.form.fields.policy_end_date": "Data de fim da apólice",
  "products.form.fields.capital_value": "Valor do capital",
  "products.form.fields.premium_value": "Valor do prêmio",
  "products.form.fields.iof_value": "Valor do IOF (%)",
  "products.form.fields.net_price": "Preço NET",
  "products.form.fields.minimum_price": "Preço Mínimo",
  "products.form.fields.maximum_price": "Preço Máximo",
  "products.form.fields.minimum_markup": "Markup Mínimo",
  "products.form.fields.maximum_markup": "Markup Máximo",
  "products.form.fields.practiced_price": "Preço Praticado",
  "products.form.fields.practiced_price_type": "Tipo do Preço Praticado",
  "products.form.fields.practiced_price_type.minimum": "Preço Mínimo",
  "products.form.fields.practiced_price_type.maximum": "Preço Máximo",
  "products.form.fields.liquid_price": "Preço Líquido",
  "products.form.fields.gross_price": "Preço Bruto",
  "products.form.fields.calculated_iof": "IOF Calculado",
  "products.form.fields.type_of_vigency": "Tipo de Vigência",
  "products.form.fields.type_of_vigency_product": "Tipo de vigência do produto",
  "products.form.fields.base_commission_for_sales_team":
    "Comissão base para equipe de vendas",
  "products.form.fields.base_commission_for_sales_manager":
    "Comissão base para gerente de vendas",
  "products.form.fields.type_of_recurrence": "Tipo de recorrência",
  "products.form.fields.type_of_recurrence.placeholder": "Selecione",
  "products.form.fields.vigency_days": "Prazo de vigência",
  "products.form.fields.discount_in_plans": "Desconto em planos",
  "products.form.fields.min_permitted_age": "Idade mínima permitida",
  "products.form.fields.max_permitted_age": "Idade máxima permitida",
  "products.form.fields.km_max_permitted": "Km máximo permitido",
  "products.form.fields.min_manufacturing_year": "Ano de fabricação mínimo permitido",
  "products.form.fields.support_materials": "Selecione os materiais de suporte",
  "products.form.fields.support_materials_web_link":
    "Link dos materiais de suporte",
  "products.form.fields.insurance_premium": "Prêmio do Seguro (R$)",
  "products.form.fields.extra_premium": "Prêmio Extra (R$)",
  "products.form.fields.total_premium": "Premio Total (R$)",
  "products.form.fields.capital_range": "Faixa de Capital",
  "products.form.fields.capital_amount": "Valor do Capital (R$)",
  "products.form.fields.permitted_age": "Idade Permitida",
  "products.form.fields.policy_code": "Código da Apólice",
  "products.form.fields.stipulant_code": "Id do estipulante",
  "products.form.fields.sub_stipulant_code": "Id do subestipulante",
  "products.form.fields.code_plan": "Código do Plano",
  "products.form.fields.extra_premium_policy_code":
    "Código Apólice Prêmio Extra",
  "products.form.fields.agency": "Agênciamento",
  "products.form.fields.lifetime": "Vitalício",
  "products.form.fields.annual": "Anual",
  "products.form.fields.lifetimeCommission": "Comissão Vitalícia",
  "products.form.fields.markup": "Mark-up (%)",
  "products.form.fields.markupIncluded": "Incluir Markup",
  "products.form.fields.markupMode": "Modo do Markup",
  "products.form.fields.markupModePercent": "Percentual (%)",
  "products.form.fields.markupModeValue": "Valor (R$)",
  "products.form.fields.markupValue": "Valor do Markup (R$)",
  "products.form.fields.max_agency": "Agenciamento Máximo %",
  "products.form.fields.agency_installments": "Parcelamento do Agenciamento",
  "products.form.fields.max_commission": "Comissão Máxima",
  "products.form.fields.plan_name_placeholder": "Nome do plano",
  "products.form.fields.plan_title_placeholder": "Nome do plano",
  "products.form.fields.plan_description": "Descrição do plano",
  "products.form.fields.plan_price": "Preço do plano",
  "products.form.actions.add_plan": "Adicionar plano",
  //products form tab commission
  "products.form.fields.net_premium": "Prêmio Líquido",
  "products.form.fields.commission_type": "Tipo de Comissão",
  "products.form.fields.commission_unique": "Comissão Única",
  "products.form.fields.commission_type.placeholder": "Selecione",
  "products.form.fields.comission": "Comissão",
  "products.form.fields.pro_labore": "Pró labore",

  //products form tab integration
  "products.form.fields.policy_holder": "Id da apolice",
  "products.form.fields.secondary_policy_holder": "Id da apolice secundária",
  "products.form.fields.insurance_policy_extra_price_code":
    "Código do preço extra da apólice",

  "product.type.insurance_personal_assistance": "Seguro AP",
  "product.type.insurance_group_life": "Seguro VG",
  "product.type.insurance_assistance": "Assistência",
  "product.type.credit": "Crédito",
  "product.type.auto": "Auto",
  "product.type.auto_insurance": "Seguro Auto",
  "product.type.moto_insurance": "Seguro Moto",
  "product.type.warranty_insurance": "Seguro Garantia",
  "product.type.theft_insurance": "Seguro Roubo e Furto",
  "product.type.health_insurance": "Seguro Saúde",
  "product.type.home_insurance": "Seguro Residencial",
  "product.type_of_vigency.pluriannual": "Plurianual",
  "product.type_of_vigency.annual": "Anual",
  "product.type_of_vigency.monthly": "Mensal",
  "product.type_of_vigency.daily": "Diário",
  "product.type_of_vigency.pay_per_use": "Pay per use",
  "product.type_of_vigency.lifetime": "Vitalícia",

  "products.warranty.tab.data": "Dados",
  "products.warranty.tab.plans": "Planos",
  "products.warranty.fields.guarantor": "Garantidora / fornecedor",
  "products.warranty.fields.emission_type": "Tipo de emissão",
  "products.warranty.emission.apolice": "Apólice",
  "products.warranty.emission.bilhete": "Bilhete",
  "products.warranty.fields.collective_policy": "Produto de apólice coletiva?",
  "products.warranty.fields.contract_active": "Contrato vigente?",
  "products.warranty.fields.contract_section_title": "Contrato vigente",
  "products.warranty.fields.contract_start": "Início da vigência do contrato",
  "products.warranty.fields.contract_end": "Fim da vigência do contrato",
  "products.warranty.vigency.pluriannual": "Plurianual",
  "products.warranty.vigency.annual": "Anual",
  "products.warranty.vigency.monthly": "Mensal",
  "products.warranty.vigency.daily": "Diário",
  "products.warranty.vigency.pay_per_use": "Pay per use",
  "products.warranty.fields.commercialization_rules": "Regras de comercialização",
  "products.warranty.rules.age": "Idade",
  "products.warranty.rules.gender": "Gênero",
  "products.warranty.rules.km": "Kilometragem",
  "products.warranty.rules.location_state": "Localização Estado",
  "products.warranty.rules.location_city": "Localização Cidade",
  "products.warranty.rules.vehicle_age": "Idade do carro/moto",
  "products.warranty.rules.vehicle_type": "Tipo de carro/moto",
  "products.warranty.rules.model_or_brand_groups":
    "Modelo e/ou grupos de marcas",
  "products.warranty.rules.custom": "Novo item",
  "products.warranty.fields.gender": "Gênero",
  "products.warranty.gender.feminine": "Feminino",
  "products.warranty.gender.masculine": "Masculino",
  "products.warranty.gender.lgbt": "LGBT",
  "products.warranty.fields.km_min": "Km mínima",
  "products.warranty.fields.km_max": "Km máxima",
  "products.warranty.fields.location_mode": "Localização",
  "products.warranty.location.states": "Estados",
  "products.warranty.location.cities": "Cidades",
  "products.warranty.fields.location_text": "Estados e cidades (texto)",
  "products.warranty.fields.vehicle_age_rule": "Idade do veículo",
  "products.warranty.vehicle_age.age_only": "Apenas idade do veículo",
  "products.warranty.vehicle_age.age_and_model": "Idade e modelo",
  "products.warranty.vehicle_age.model_or_groups": "Modelo e/ou grupos de marcas",
  "products.warranty.fields.vehicle_age_only_min": "Idade (anos)",
  "products.warranty.fields.vehicle_age_and_model_rules": "Regras idade e modelo",
  "products.warranty.fields.vehicle_type_rules": "Regras tipo / marcas",
  "products.warranty.fields.excluded_items": "Itens não cobertos",
  "products.warranty.fields.premium_price_type": "Preço do seguro (prêmio)",
  "products.pricing.sale_price_product": "Preço de venda (R$)",
  "products.pricing.sale_price_plan": "Preço de venda do plano (R$)",
  "products.pricing.minimum_price_product": "Preço mínimo (R$)",
  "products.pricing.maximum_price_product": "Preço máximo (R$)",
  "products.pricing.cost_price": "Preço de custo (NET + Gateway)",
  "products.pricing.sale_price_calculated": "Preço de venda",
  "products.pricing.minimum_equals_sale":
    "Igual ao preço de venda calculado (custo + markup).",
  "products.pricing.minimum_editable_hint":
    "Valor mínimo do produto; pode ser ajustado manualmente.",
  "products.pricing.commission_percent_hint":
    "Percentual informativo; não entra no cálculo do gateway.",
  "products.pricing.validation.minimum_required":
    "Informe o preço mínimo do produto.",
  "products.pricing.validation.minimum_above_max":
    "O preço mínimo não pode ser maior que o preço máximo.",
  "products.pricing.plan_cost_calculated": "Valor de custo (calculado)",
  "products.pricing.plan_limits_from_product":
    "Custo e limites definidos na aba Dados do produto.",
  "products.pricing.plan_sale_within_limits":
    "O preço de venda do plano deve estar entre o mínimo e o máximo do produto.",
  "products.pricing.validation.maximum_required":
    "Informe o preço máximo ou marque como ilimitado.",
  "products.pricing.validation.plan_sale_required":
    "Informe o preço de venda do plano.",
  "products.pricing.validation.plan_sale_below_min":
    "O preço de venda do plano não pode ser menor que o preço mínimo do produto.",
  "products.pricing.validation.plan_sale_above_max":
    "O preço de venda do plano não pode ser maior que o preço máximo do produto.",
  "products.gateway.sectionTitle": "Custos do gateway Soulhub",
  "products.gateway.fields.fee_percent": "% do gateway sobre o produto",
  "products.gateway.fields.fee_per_sale": "Taxa por venda do gateway (R$)",
  "products.gateway.fields.net_with_gateway_costs": "NET + custos do gateway",
  "products.gateway.fields.net_plus_fixed_fee": "Prêmio (NET) + taxa fixa por venda",
  "products.gateway.fields.net_plus_fixed_fee_hint":
    "Soma do prêmio NET informado e da taxa fixa por venda do gateway.",
  "products.gateway.fields.net_with_gateway_costs_hint":
    "NET + (NET × % gateway) + taxa fixa por venda",
  "products.gateway.fields.sale_price": "Preço de venda (R$)",
  "products.gateway.plan.unlimited_max": "Ilimitado",
  "products.gateway.plan.unlimited_max_active": "Preço máximo ilimitado ativo",
  "products.gateway.validation.fee_percent_required":
    "Informe o percentual do gateway Soulhub.",
  "products.gateway.validation.fee_per_sale_required":
    "Informe a taxa por venda do gateway Soulhub.",
  "products.gateway.validation.plan_cost_required":
    "Informe o valor de custo do plano.",
  "products.gateway.validation.plan_min_required":
    "Informe o preço mínimo do plano.",
  "products.warranty.premium.net": "Preço NET",
  "products.warranty.premium.commissioned": "Preço comissionado",
  "products.warranty.fields.net_price": "Preço NET (R$)",
  "products.warranty.fields.commissioned_price": "Preço comissionado (R$)",
  "products.warranty.fields.commission_percent": "Comissão (%)",
  "products.warranty.fields.markup_enabled": "Markup",
  "products.warranty.fields.markup_mode": "Tipo de markup",
  "products.warranty.markup.mode_percent_on_net": "Percentual (%) sobre o preço de custo",
  "products.warranty.markup.mode_fixed_value": "Valor fixo (R$) sobre o preço de custo",
  "products.warranty.fields.net_price_markup_base":
    "Preço NET — base do markup (%) (R$)",
  "products.warranty.fields.markup_value_currency": "Valor do markup (R$)",
  "products.warranty.fields.markup_value_percent": "Markup (%)",
  "products.warranty.fields.pro_labore_enabled": "Pró-labore",
  "products.warranty.fields.pro_labore_mode": "Modo do pró-labore",
  "products.warranty.pro_labore.real": "Valor (R$)",
  "products.warranty.pro_labore.percent": "Percentual (%)",
  "products.warranty.pro_labore.custom_rule": "Regra customizada",
  "products.warranty.fields.pro_labore_custom_rule": "Descrição da regra",
  "products.warranty.fields.pro_labore_value": "Valor pró-labore",
  "products.warranty.fields.has_additional_plans": "Seguro possui outros planos?",
  "products.warranty.fields.infinity_sync_as_source": "Sincronizar como origem Infinity → Soulhub",
  "products.warranty.plans.disabled_hint": "Ative \"Seguro possui outros planos?\" na aba Dados para cadastrar planos.",
  "products.warranty.plans.plan_prefix": "Plano",
  "products.warranty.plans.name": "Nome do plano",
  "products.warranty.plans.description": "Descrição do plano",
  "products.warranty.plans.new_coverages": "Novas coberturas",
  "products.warranty.plans.adjustments": "Ajustes dos planos",
  "products.warranty.plans.adjustment_type": "Tipo de ajuste",
  "products.warranty.adjustment.lmi": "LMI (limite máximo indenização)",
  "products.warranty.adjustment.is": "IS (importância segurada)",
  "products.warranty.adjustment.ages": "Idades",
  "products.warranty.adjustment.usage_qty_in_term": "Quantidade de utilização na vigência",
  "products.warranty.adjustment.additional_assistance": "Assistência adicional",
  "products.warranty.adjustment.custom": "Novo item",
  "products.warranty.plans.new_assistance_value": "Novo valor da assistência?",
  "products.warranty.plans.assistance_value_amount": "Valor assistência (R$)",
  "products.warranty.plans.new_commission": "Novo valor de comissionamento?",
  "products.warranty.plans.commission_percent": "Comissionamento (%)",
  "products.warranty.plans.additional_assistance_text": "Assistência adicional (texto)",
  "products.warranty.plans.add": "Adicionar plano",
  "products.warranty.plans.add_adjustment": "Adicionar ajuste",
  "products.warranty.actions.save": "Salvar",
  "products.warranty.actions.update": "Atualizar produto",
  "products.theft.tab.data": "Dados",
  "products.theft.tab.plans": "Planos",
  "products.theft.fields.guarantor": "Garantidora / fornecedor",
  "products.theft.fields.emission_type": "Tipo de emissão",
  "products.theft.emission.apolice": "Apólice",
  "products.theft.emission.bilhete": "Bilhete",
  "products.theft.fields.collective_policy": "Produto de apólice coletiva?",
  "products.theft.fields.contract_active": "Contrato vigente?",
  "products.theft.fields.contract_start": "Início da vigência do contrato",
  "products.theft.fields.contract_end": "Fim da vigência do contrato",
  "products.theft.vigency.pluriannual": "Plurianual",
  "products.theft.vigency.annual": "Anual",
  "products.theft.vigency.monthly": "Mensal",
  "products.theft.vigency.daily": "Diário",
  "products.theft.vigency.pay_per_use": "Pay per use",
  "products.theft.fields.commercialization_rules": "Regras de comercialização",
  "products.theft.rules.age": "Idade",
  "products.theft.rules.gender": "Gênero",
  "products.theft.rules.km": "Kilometragem",
  "products.theft.rules.location_state": "Localização Estado",
  "products.theft.rules.location_city": "Localização Cidade",
  "products.theft.rules.vehicle_age": "Idade do carro/moto",
  "products.theft.rules.vehicle_type": "Tipo de carro/moto",
  "products.theft.rules.model_or_brand_groups":
    "Modelo e/ou grupos de marcas",
  "products.theft.rules.custom": "Novo item",
  "products.theft.fields.gender": "Gênero",
  "products.theft.gender.feminine": "Feminino",
  "products.theft.gender.masculine": "Masculino",
  "products.theft.gender.lgbt": "LGBT",
  "products.theft.fields.km_min": "Km mínima",
  "products.theft.fields.km_max": "Km máxima",
  "products.theft.fields.location_mode": "Localização",
  "products.theft.location.states": "Estados",
  "products.theft.location.cities": "Cidades",
  "products.theft.fields.location_text": "Estados e cidades (texto)",
  "products.theft.fields.vehicle_age_rule": "Idade do veículo",
  "products.theft.vehicle_age.age_only": "Apenas idade do veículo",
  "products.theft.vehicle_age.age_and_model": "Idade e modelo",
  "products.theft.vehicle_age.model_or_groups": "Modelo e/ou grupos de marcas",
  "products.theft.fields.vehicle_age_only_min": "Idade (anos)",
  "products.theft.fields.vehicle_age_and_model_rules": "Regras idade e modelo",
  "products.theft.fields.vehicle_type_rules": "Regras tipo / marcas",
  "products.theft.fields.excluded_items": "Itens não cobertos",
  "products.theft.fields.premium_price_type": "Preço do seguro (prêmio)",
  "products.theft.premium.net": "Preço NET",
  "products.theft.premium.commissioned": "Preço comissionado",
  "products.theft.fields.net_price": "Preço NET (R$)",
  "products.theft.fields.commissioned_price": "Preço comissionado (R$)",
  "products.theft.fields.commission_percent": "Comissão (%)",
  "products.theft.fields.markup_enabled": "Markup",
  "products.theft.fields.markup_mode": "Tipo de markup",
  "products.theft.markup.mode_percent_on_net": "Percentual (%) sobre o preço de custo",
  "products.theft.markup.mode_fixed_value": "Valor fixo (R$) sobre o preço de custo",
  "products.theft.fields.net_price_markup_base":
    "Preço NET — base do markup (%) (R$)",
  "products.theft.fields.markup_value_currency": "Valor do markup (R$)",
  "products.theft.fields.markup_value_percent": "Markup (%)",
  "products.theft.fields.pro_labore_enabled": "Pró-labore",
  "products.theft.fields.pro_labore_mode": "Modo do pró-labore",
  "products.theft.pro_labore.real": "Valor (R$)",
  "products.theft.pro_labore.percent": "Percentual (%)",
  "products.theft.pro_labore.custom_rule": "Regra customizada",
  "products.theft.fields.pro_labore_custom_rule": "Descrição da regra",
  "products.theft.fields.pro_labore_value": "Valor pró-labore",
  "products.theft.fields.has_additional_plans": "Seguro possui outros planos?",
  "products.theft.fields.infinity_sync_as_source": "Sincronizar como origem Infinity → Soulhub",
  "products.theft.plans.disabled_hint": "Ative \"Seguro possui outros planos?\" na aba Dados para cadastrar planos.",
  "products.theft.plans.plan_prefix": "Plano",
  "products.theft.plans.name": "Nome do plano",
  "products.theft.plans.description": "Descrição do plano",
  "products.theft.plans.new_coverages": "Novas coberturas",
  "products.theft.plans.adjustments": "Ajustes dos planos",
  "products.theft.plans.adjustment_type": "Tipo de ajuste",
  "products.theft.adjustment.lmi": "LMI (limite máximo indenização)",
  "products.theft.adjustment.is": "IS (importância segurada)",
  "products.theft.adjustment.ages": "Idades",
  "products.theft.adjustment.usage_qty_in_term": "Quantidade de utilização na vigência",
  "products.theft.adjustment.additional_assistance": "Assistência adicional",
  "products.theft.adjustment.custom": "Novo item",
  "products.theft.plans.new_assistance_value": "Novo valor da assistência?",
  "products.theft.plans.assistance_value_amount": "Valor assistência (R$)",
  "products.theft.plans.new_commission": "Novo valor de comissionamento?",
  "products.theft.plans.commission_percent": "Comissionamento (%)",
  "products.theft.plans.additional_assistance_text": "Assistência adicional (texto)",
  "products.theft.plans.add": "Adicionar plano",
  "products.theft.plans.add_adjustment": "Adicionar ajuste",
  "products.theft.actions.save": "Salvar",
  "products.theft.actions.update": "Atualizar produto",

  "combo.form.title": "Novo combo",
  "combo.form.description": "Crie um novo combo",
  "combo.form.button.close": "Fechar",
  "combo.form.fields.name": "Nome do combo",
  "combo.form.fields.value": "Valor do combo",
  "combo.form.button.create": "Criar combo",

  //campaigns
  "campaigns.title": "Campanhas",
  "campaigns.description": "Gerencie suas campanhas",
  "campaigns.no_campaigns": "Nenhuma campanha encontrada",
  "campaigns.table.name": "Nome",
  "campaigns.table.project": "Projeto",
  "campaigns.table.plan": "Plano",
  "campaigns.table.channel": "Canal",
  "campaigns.table.status": "Status",
  "campaigns.form.fields.name": "Nome da campanha",
  "campaigns.form.fields.project": "Projeto",
  "campaigns.form.fields.projectPlaceholder": "Selecione um projeto",
  "campaigns.form.fields.plan": "Plano(s) associado(s)",
  "campaigns.form.fields.channel": "Canal",
  "campaigns.form.fields.status.label": "Status",
  "campaigns.form.fields.status.options.draft": "Rascunho",
  "campaigns.form.fields.status.options.active": "Ativa",
  "campaigns.form.fields.status.options.paused": "Pausada",
  "campaigns.form.noProjectSelected": "Selecione um projeto para carregar os planos.",
  "campaigns.form.noPlansForOrganization":
    "Nenhum plano encontrado para esta organização.",
  "campaigns.form.noPlansForProject": "Nenhum plano encontrado para este projeto.",
  "campaigns.form.editTitle": "Editar campanha",
  "campaigns.form.whatsappMetaSection": "WhatsApp (Meta) — disparo por template",
  "campaigns.form.whatsappMetaConfig": "Conexão Meta",
  "campaigns.form.whatsappMetaConfigPlaceholder": "Selecione uma conexão salva",
  "campaigns.form.whatsappSenderPhone": "Número remetente (Graph)",
  "campaigns.form.whatsappSenderPhonePlaceholder": "Selecione o ID do número de envio",
  "campaigns.form.whatsappTemplate": "Template aprovado",
  "campaigns.form.whatsappTemplatePlaceholder": "Selecione nome e idioma do template",
  "campaigns.form.whatsappBodyParams": "Parâmetros do corpo (um por linha)",
  "campaigns.form.whatsappBodyParamsHint":
    "Para placeholders posicionais, uma linha por valor (ordem {{1}}, {{2}}, …). Para placeholders nomeados, uma linha por variável: nome=valor (ex.: nome=João). Não misture os dois formatos. Deixe vazio se não houver variáveis.",
  "campaigns.form.whatsappMetaIncomplete":
    "Preencha todos os campos Meta (conexão, número remetente, nome e idioma do template) ou deixe todos vazios.",
  "campaigns.channel.whatsapp": "WhatsApp",
  "campaigns.status.draft": "Rascunho",
  "campaigns.status.active": "Ativa",
  "campaigns.status.paused": "Pausada",
  "campaigns.success.created": "Campanha criada com sucesso",
  "campaigns.success.updated": "Campanha atualizada com sucesso",
  "campaigns.success.deleted": "Campanha removida com sucesso",
  "campaigns.errors.loadingPlans": "Não foi possível carregar os planos do projeto.",
  "campaigns.errors.loadingProjects": "Não foi possível carregar os projetos.",
  "campaigns.errors.planNotInProject":
    "Um ou mais planos selecionados não pertencem ao projeto selecionado.",
  "campaigns.actions.viewCampaigns": "Ver campanhas",
  "campaigns.actions.viewDetails": "Ver detalhes",
  "campaigns.actions.uploadList": "Upload de lista",
  "campaigns.dashboard.total": "Total de campanhas",
  "campaigns.dashboard.active": "Ativas",
  "campaigns.dashboard.draft": "Rascunho",
  "campaigns.dashboard.paused": "Pausadas",
  "campaigns.upload.title": "Upload de contatos",
  "campaigns.upload.description":
    "Envie um arquivo CSV ou XLSX para processar contatos da campanha.",
  "campaigns.upload.form.title":
    "Arraste e solte seu arquivo aqui ou clique para selecionar",
  "campaigns.upload.form.downloadTemplate": "Baixar planilha modelo",
  "campaigns.upload.form.description":
    "Formatos aceitos: .csv e .xlsx. Telefone é obrigatório.",
  "campaigns.upload.form.submit": "Processar lista",
  "campaigns.upload.processing": "Processando arquivo...",
  "campaigns.upload.success.processed": "Lista processada com sucesso",
  "campaigns.upload.summary.valid": "Válidos",
  "campaigns.upload.summary.invalid": "Inválidos",
  "campaigns.upload.summary.duplicate": "Duplicados",
  "campaigns.upload.summary.inserted": "Inseridos",
  "campaigns.upload.preview.title": "Pré-visualização (amostra)",
  "campaigns.upload.preview.empty":
    "Selecione um arquivo para visualizar as linhas processadas.",
  "campaigns.upload.preview.columns.line": "Linha",
  "campaigns.upload.preview.columns.company": "Empresa",
  "campaigns.upload.preview.columns.first_name": "Nome",
  "campaigns.upload.preview.columns.last_name": "Sobrenome",
  "campaigns.upload.preview.columns.email": "E-mail",
  "campaigns.upload.preview.columns.name": "Nome",
  "campaigns.upload.preview.columns.phone": "Telefone",
  "campaigns.upload.preview.columns.phone_2": "Telefone 2",
  "campaigns.upload.preview.columns.document_number": "CNPJ/CPF",
  "campaigns.upload.preview.columns.status": "Status",
  "campaigns.upload.preview.columns.reason": "Motivo",
  "campaigns.upload.status.valid": "Válido",
  "campaigns.upload.status.invalid": "Inválido",
  "campaigns.upload.status.duplicate": "Duplicado",
  "campaigns.upload.validation.invalidExtension":
    "Selecione um arquivo .csv ou .xlsx",
  "campaigns.upload.errors.generic":
    "Não foi possível processar o arquivo. Tente novamente.",
  "campaigns.upload.errors.templateDownload":
    "Não foi possível baixar a planilha modelo.",
  "campaigns.upload.errors.invalidFile":
    "Não foi possível ler o arquivo selecionado.",
  "campaigns.upload.errors.phoneColumnMissing":
    "A coluna de telefone é obrigatória no arquivo enviado.",
  "campaigns.upload.errors.campaignNotFound":
    "Campanha não encontrada para este upload.",
  "campaigns.upload.errors.campaignIdMissing":
    "Não foi possível identificar a campanha para upload.",
  "campaigns.upload.modal.title": "Enviar lista de leads",
  "campaigns.upload.modal.description":
    "Baixe o modelo, preencha com seus contatos e envie o arquivo em CSV ou XLSX.",
  "campaigns.upload.modal.templateLabel": "Modelo de planilha",
  "campaigns.upload.modal.uploadLabel": "Enviar arquivo",
  "campaigns.upload.modal.selectFromComputer": "Selecionar arquivo do computador",
  "campaigns.upload.modal.templateDownloaded": "Modelo baixado com sucesso.",
  "campaigns.upload.modal.selectFileFirst": "Selecione ou arraste um arquivo para enviar.",
  "campaigns.upload.modal.fileLoaded": "Arquivo pronto para envio. Clique em X para trocar.",
  "campaigns.details.title": "Detalhes da campanha",
  "campaigns.details.description":
    "Visualize os dados da campanha e os contatos já carregados.",
  "campaigns.details.emptyCampaign": "Campanha não encontrada.",
  "campaigns.details.info.title": "Dados da campanha",
  "campaigns.details.info.name": "Nome",
  "campaigns.details.info.status": "Status",
  "campaigns.details.info.channel": "Canal",
  "campaigns.details.info.projectId": "Projeto",
  "campaigns.details.info.plans": "Planos",
  "campaigns.details.info.whatsappTemplate": "Template WhatsApp (Meta)",
  "campaigns.details.dispatch.button": "Disparar template para todos os contatos",
  "campaigns.details.dispatch.dialogTitle": "Disparo WhatsApp",
  "campaigns.details.dispatch.dialogDescription":
    "Escolha a conexão Meta, o número remetente e o template. Os valores podem vir pré-preenchidos da campanha se você os salvou na edição.",
  "campaigns.details.dispatch.bodyParamsHint":
    "Opcional: se o corpo do template na Meta tiver só variáveis name/nome e message/mensagem, pode deixar este campo vazio — o sistema preenche com cada lead. Se tiver só {{1}} e {{2}}, também pode deixar vazio ({{1}} = nome do lead, {{2}} = mensagem inicial da IA). Caso contrário, use uma linha por variável (nome=valor); name/nome e mensagem/message podem ter valor vazio. Enriqueça os contatos antes para a mensagem inicial. Não misture linhas posicionais puras com nome=valor.",
  "campaigns.details.dispatch.dialogSubmit": "Continuar para confirmação",
  "campaigns.details.dispatch.confirmTitle":
    "Enviar template WhatsApp para todos os leads?",
  "campaigns.details.dispatch.confirmDescription":
    "Serão disparadas chamadas à Cloud API da Meta para cada contato desta campanha. Use apenas para base com opt-in. A operação pode levar vários minutos.",
  "campaigns.details.dispatch.successTitle": "Disparo concluído",
  "campaigns.details.dispatch.successSent": "Enviados",
  "campaigns.details.dispatch.successFailed": "Falhas",
  "campaigns.details.dispatch.successTotal": "Total",
  "campaigns.details.contacts.title": "Contatos carregados",
  "campaigns.details.contacts.empty":
    "Nenhum contato carregado para esta campanha.",
  "campaigns.details.contacts.columns.company": "Empresa",
  "campaigns.details.contacts.columns.name": "Nome",
  "campaigns.details.contacts.columns.first_name": "Nome",
  "campaigns.details.contacts.columns.last_name": "Sobrenome",
  "campaigns.details.contacts.columns.email": "E-mail",
  "campaigns.details.contacts.columns.phone": "Telefone",
  "campaigns.details.contacts.columns.phone_2": "Telefone 2",
  "campaigns.details.contacts.columns.document_number": "CNPJ/CPF",
  "campaigns.details.contacts.columns.createdAt": "Carregado em",
  "campaigns.details.dashboard.totalContacts": "Total de contatos",
  "campaigns.details.dashboard.withName": "Contatos com nome",
  "campaigns.details.dashboard.withoutName": "Sem nome",
  "campaigns.details.dashboard.lastUpload": "Último carregamento",

  "campaigns.dashboard.export": "Exportar",
  "campaigns.dashboard.pause": "Pausar",
  "campaigns.dashboard.resume": "Retomar",
  "campaigns.dashboard.adjustSettings": "Ajustar configurações",
  "campaigns.dashboard.unitCostBadge": "Custo unitário: {{value}}",
  "campaigns.dashboard.kpi.sent": "Envios realizados",
  "campaigns.dashboard.kpi.sentToday": "+ hoje: {{count}}",
  "campaigns.dashboard.kpi.delivered": "Entregues",
  "campaigns.dashboard.kpi.deliveryRate": "Taxa {{value}}%",
  "campaigns.dashboard.kpi.chats": "Chats iniciados",
  "campaigns.dashboard.kpi.chatConversion": "Conversão {{value}}%",
  "campaigns.dashboard.kpi.totalCost": "Custo total",
  "campaigns.dashboard.kpi.projection":
    "Projeção {{value}} (se +20% de envios)",
  "campaigns.dashboard.funnel.title": "Funil de execução",
  "campaigns.dashboard.funnel.subtitle":
    "Visão rápida de envios → entregues → chats iniciados.",
  "campaigns.dashboard.funnel.refresh": "Atualizar",
  "campaigns.dashboard.funnel.range7": "Últimos 7 dias",
  "campaigns.dashboard.funnel.range30": "Últimos 30 dias",
  "campaigns.dashboard.funnel.range90": "Últimos 90 dias",
  "campaigns.dashboard.funnel.sent": "Envios",
  "campaigns.dashboard.funnel.delivered": "Entregues",
  "campaigns.dashboard.funnel.chats": "Chats iniciados",
  "campaigns.dashboard.runs.title": "Envios recentes",
  "campaigns.dashboard.runs.subtitle": "Auditoria rápida por lote e status.",
  "campaigns.dashboard.runs.searchPlaceholder":
    "Buscar por lote ou template",
  "campaigns.dashboard.runs.colDate": "Data/Hora",
  "campaigns.dashboard.runs.colBatch": "Lote",
  "campaigns.dashboard.runs.colTemplate": "Template",
  "campaigns.dashboard.runs.colSent": "Envios",
  "campaigns.dashboard.runs.colDelivered": "Entregues",
  "campaigns.dashboard.runs.colChats": "Chats",
  "campaigns.dashboard.runs.colCost": "Custo",
  "campaigns.dashboard.costs.title": "Custos",
  "campaigns.dashboard.costs.subtitle": "Custo estimado por disparo e breakdown.",
  "campaigns.dashboard.costs.perDispatch": "Custo por disparo",
  "campaigns.dashboard.costs.budget": "Orçamento (opcional)",
  "campaigns.dashboard.costs.used": "Usado {{value}}%",
  "campaigns.dashboard.costs.tip":
    "Dica: defina um orçamento para acompanhar o uso na campanha.",
  "campaigns.dashboard.actions.title": "Ações rápidas",
  "campaigns.dashboard.actions.subtitle": "Operação sem sair da tela.",
  "campaigns.dashboard.actions.retryFailed": "Reprocessar falhas",
  "campaigns.dashboard.actions.changeTemplate": "Trocar template",
  "campaigns.dashboard.actions.newBatch": "Novo lote",
  "campaigns.dashboard.costSheet.title": "Custos da campanha",
  "campaigns.dashboard.costSheet.unit": "Custo unitário (R$)",
  "campaigns.dashboard.costSheet.budget": "Orçamento (R$, opcional)",
  "campaigns.dashboard.costSheet.save": "Salvar",
  "campaigns.dashboard.costSheet.invalidMoney":
    "Informe valores numéricos válidos (ex.: 0,44).",
  "campaigns.dashboard.costSheet.success": "Custos atualizados.",
  "campaigns.dashboard.pauseSuccess": "Campanha pausada.",
  "campaigns.dashboard.resumeSuccess": "Campanha reativada.",
  "campaigns.dashboard.na": "—",
  "campaigns.dashboard.windowHint": "Filtro do funil e da tabela",
  "campaigns.dashboard.headerPeriod": "Período: últimos {{days}} dias",

  "campaigns.details.errors.loadCampaign":
    "Não foi possível carregar os dados da campanha.",
  "campaigns.details.errors.loadContacts":
    "Não foi possível carregar os contatos da campanha.",
  "campaigns.details.enrich.button": "Enriquecer dados",
  "campaigns.details.enrich.buttonLoading": "Enriquecendo...",
  "campaigns.details.enrich.banner": "Enriquecendo contatos. Aguarde...",
  "campaigns.details.enrich.bannerAi": "Enriquecendo contatos com IA. Aguarde...",
  "campaigns.details.enrich.success": "Enriquecimento concluído.",
  "campaigns.details.enrich.successProcessed": "contato(s) enriquecido(s).",
  "campaigns.details.enrich.error": "Falha ao enriquecer contatos.",
  "campaigns.details.enrich.failedCount": "contato(s) com erro.",
  "campaigns.details.contacts.columns.enrichmentStatus": "Status",
  "campaigns.details.contacts.columns.enrichedData": "Perfil",
  "campaigns.details.contacts.columns.initialMessage": "Mensagem inicial",
  "campaigns.details.contacts.enrichment.enriched": "Enriquecido",
  "campaigns.details.contacts.enrichment.pending": "Pendente",
  "campaigns.details.contacts.enrichment.failed": "Erro",
  "campaigns.details.contacts.testFlow": "Testar fluxo",
  "campaigns.details.chat.title": "Testar chat",
  "campaigns.details.chat.placeholder": "Digite sua mensagem...",
  "campaigns.details.chat.send": "Enviar",
  "campaigns.details.chat.typing": "Digitando...",
  "campaigns.details.chat.openingGeneric": "Olá!",
  "campaigns.details.chat.openingNamed": "Olá, {{name}}!",

  "campaigns.whatsappMeta.title": "WhatsApp (Meta)",
  "campaigns.whatsappMeta.description":
    "Conecte o WABA com token da Graph API e consulte números e templates aprovados (somente leitura).",
  "campaigns.whatsappMeta.add": "Nova conexão",
  "campaigns.whatsappMeta.edit": "Editar conexão",
  "campaigns.whatsappMeta.cancel": "Cancelar",
  "campaigns.whatsappMeta.save": "Salvar",
  "campaigns.whatsappMeta.delete": "Excluir",
  "campaigns.whatsappMeta.dialogIntro":
    "Informe o WABA ID e o access token com permissão para o WhatsApp Business Account. O cadastro de números e templates continua no Gerenciador da Meta.",
  "campaigns.whatsappMeta.tokenOptionalOnEdit":
    "Deixe o token em branco para manter o atual.",
  "campaigns.whatsappMeta.empty": "Nenhuma conexão cadastrada.",
  "campaigns.whatsappMeta.workflowNote":
    "Abra uma conexão na tabela para ver números e templates da Meta em uma tela dedicada.",
  "campaigns.whatsappMeta.connectionsTitle": "Conexões",
  "campaigns.whatsappMeta.backToList": "Voltar às conexões",
  "campaigns.whatsappMeta.notFound":
    "Esta conexão não existe mais ou você não tem acesso.",
  "campaigns.whatsappMeta.selectConnectionHint":
    "Selecione uma conexão na tabela acima para ver números e templates.",
  "campaigns.whatsappMeta.phoneNumbersTitle": "Números (Meta)",
  "campaigns.whatsappMeta.phoneNumbersEmpty":
    "Nenhum número retornado pela Meta para este WABA.",
  "campaigns.whatsappMeta.templatesTitle": "Templates (Meta)",
  "campaigns.whatsappMeta.templatesEmpty":
    "Nenhum template retornado pela Meta.",
  "campaigns.whatsappMeta.loadMoreTemplates": "Carregar mais templates",
  "campaigns.whatsappMeta.fields.label": "Nome da conexão (opcional)",
  "campaigns.whatsappMeta.fields.wabaId": "WABA ID",
  "campaigns.whatsappMeta.fields.accessToken": "Access token",
  "campaigns.whatsappMeta.table.label": "Nome",
  "campaigns.whatsappMeta.table.wabaId": "WABA ID",
  "campaigns.whatsappMeta.table.token": "Token",
  "campaigns.whatsappMeta.table.actions": "Ações",
  "campaigns.whatsappMeta.tokenConfigured": "Configurado",
  "campaigns.whatsappMeta.tokenMissing": "—",
  "campaigns.whatsappMeta.phoneTable.display": "Número",
  "campaigns.whatsappMeta.phoneTable.verifiedName": "Nome verificado",
  "campaigns.whatsappMeta.phoneTable.id": "ID",
  "campaigns.whatsappMeta.templatesTable.name": "Nome",
  "campaigns.whatsappMeta.templatesTable.status": "Status",
  "campaigns.whatsappMeta.templatesTable.language": "Idioma",
  "campaigns.whatsappMeta.templatesDetail.hint":
    "Abra um template para ver categoria, ID na Graph, indicador de qualidade e cada componente (cabeçalho, corpo com variáveis, rodapé e botões).",
  "campaigns.whatsappMeta.templatesDetail.category": "Categoria",
  "campaigns.whatsappMeta.templatesDetail.templateId": "ID do template",
  "campaigns.whatsappMeta.templatesDetail.qualityScore": "Pontuação de qualidade",
  "campaigns.whatsappMeta.templatesDetail.structure": "Estrutura (componentes Meta)",
  "campaigns.whatsappMeta.templatesDetail.noComponents":
    "A Meta não retornou componentes para este template.",
  "campaigns.whatsappMeta.templatesDetail.emptyComponents": "Lista de componentes vazia.",
  "campaigns.whatsappMeta.templatesDetail.component.buttons": "Botões",
  "campaigns.whatsappMeta.templatesDetail.component.noText":
    "Sem texto neste componente (ex.: cabeçalho de mídia ou só dinâmico).",
  "campaigns.whatsappMeta.deleteConfirmTitle": "Excluir conexão?",
  "campaigns.whatsappMeta.deleteConfirmDescription":
    "Esta ação remove a conexão salva no Infinity. Nada é alterado na Meta.",
  "campaigns.whatsappMeta.success.created": "Conexão criada com sucesso",
  "campaigns.whatsappMeta.success.updated": "Conexão atualizada com sucesso",
  "campaigns.whatsappMeta.success.deleted": "Conexão removida com sucesso",
  "campaigns.whatsappMeta.errors.loadConfigs":
    "Não foi possível carregar as conexões. Verifique sua sessão e tente novamente.",

  //components upload-avatar
  "components.uploadAvatar.changePictureButton": "Alterar foto",
  "components.uploadAvatar.changePictureButtonDescription":
    "Formatos aceitos: JPG, JPEG, PNG ou GIF. Tamanho máximo de 5MB.",
  "components.uploadAvatar.clickToCrop": "Clique para cortar",

  //equipe
  "users.tabs.data": "Dados",
  "users.fields.firstName": "Nome",
  "users.fields.lastName": "Sobrenome",
  "users.fields.document": "Documento",
  "users.fields.birthDate": "Data de nascimento",
  "users.fields.phone": "Telefone",
  "users.fields.zipcode": "CEP",
  "users.fields.state": "Estado",
  "users.fields.city": "Cidade",
  "users.fields.neighborhood": "Bairro",
  "users.fields.street": "Rua",
  "users.fields.number": "Número",
  "users.fields.complement": "Complemento",

  "users.tabs.login": "Login",
  "users.fields.email": "E-mail",
  "users.fields.password": "Senha",
  "users.fields.recoveryEmail": "E-mail de recuperação",
  "users.fields.documentType": "Document type",
  "users.fields.usbKey": "Chave USB",

  "users.tabs.permissions": "Permissões",
  "users.fields.selectAccessLevel": "Selecione o nível de acesso",
  "users.roles.admin": "Administrador",
  "users.roles.sales": "Vendas",
  "users.roles.support": "Suporte",
  "users.roles.reportsViewOnly": "Relatórios (Somente Visualização)",

  "users.permissions.orSelectIndividually": "Ou selecione individualmente",
  "users.permissions.selectAll": "Selecionar todos",
  "users.permissions.createProducts": "Criar Produtos",
  "users.permissions.createUsers": "Criar Usuários",
  "users.permissions.createCampaigns": "Criar Campanhas",
  "users.permissions.accessFinancialReports": "Acessar Relatórios Financeiros",
  "users.permissions.manageClients": "Gerenciar Parceiros",
  "users.permissions.accessSalesDashboard": "Acessar Dashboard de Vendas",
  "users.permissions.createPlatforms": "Criar Plataformas",
  "users.permissions.manageCancellations": "Gerenciar Cancelamentos",
  "users.permissions.accessDashboard": "Acessar Dashboard",
  "users.permissions.createTeams": "Criar Equipes",

  "users.permissions.subtitles.createProducts":
    "O usuário tem permissão para cadastrar qualquer produto na plataforma",
  "users.permissions.subtitles.createUsers":
    "O usuário tem permissão para cadastrar novos usuários na plataforma",
  "users.permissions.subtitles.createCampaigns":
    "O usuário tem permissão para criar campanhas publicitárias na plataforma",
  "users.permissions.subtitles.accessFinancialReports":
    "O usuário tem permissão para acessar relatórios financeiros da plataforma",
  "users.permissions.subtitles.manageClients":
    "O usuário tem permissão para gerenciar Parceiros na plataforma",
  "users.permissions.subtitles.accessSalesDashboard":
    "O usuário tem permissão para acessar o dashboard de vendas da plataforma",
  "users.permissions.subtitles.createPlatforms":
    "O usuário tem permissão para criar novas plataformas na plataforma",
  "users.permissions.subtitles.manageCancellations":
    "O usuário tem permissão para gerenciar cancelamentos de serviços na plataforma",
  "users.permissions.subtitles.accessDashboard":
    "O usuário tem permissão para acessar o dashboard principal da plataforma",
  "users.permissions.subtitles.createTeams":
    "O usuário tem permissão para criar equipes na plataforma",
  "users.no_users": "Nenhum usuário encontrado",

  //reports
  "reports.title": "Relatórios de Vendas",
  "reports.description": "Visualize e analise as vendas realizadas",
  "reports.tabs.general": "Vendas gerais",
  "reports.tabs.supplier": "Por Fornecedor",
  "reports.supplierTab.description":
    "Selecione o fornecedor para ver as vendas dos produtos dele em cada plano, com o valor do plano e o valor do produto.",
  "reports.supplierTab.filtersTitle": "Filtros por fornecedor",
  "reports.supplierTab.supplier": "Fornecedor",
  "reports.supplierTab.supplierPlaceholder": "Selecione o fornecedor",
  "reports.supplierTab.apply": "Buscar vendas",
  "reports.supplierTab.viewingSupplier": "Exibindo vendas de",
  "reports.supplierTab.emptyHint":
    "Selecione um fornecedor e clique em Buscar vendas para ver o relatório dos produtos dele.",
  "reports.supplierTab.supplierRequired":
    "Selecione um fornecedor para continuar.",
  "reports.supplierTab.supplierRequiredTitle": "Fornecedor obrigatório",
  "reports.noSales": "Nenhuma venda encontrada",

  //reports table
  "reports.table.saleId": "ID da Venda",
  "reports.table.planName": "Nome do Plano",
  "reports.table.partnerName": "Parceiro",
  "reports.table.clientName": "Cliente",
  "reports.table.clientCpf": "CPF do Cliente",
  "reports.table.salePrice": "Preço de Venda",
  "reports.table.status": "Status",
  "reports.table.saleDate": "Data da Venda",
  "reports.table.details": "Detalhes",
  "reports.table.viewDetails": "Ver Detalhes",

  //reports status
  "reports.status.pending": "Pendente",
  "reports.status.approved": "Aprovada",
  "reports.status.failed": "Falhou",
  "reports.status.refunded": "Reembolsada",
  "reports.status.rejected": "Rejeitada",
  "reports.status.cancelled": "Cancelada",

  //reports filters
  "reports.filters.title": "Filtros",
  "reports.filters.saleId": "ID da Venda",
  "reports.filters.saleIdPlaceholder":
    "Digite um ou mais IDs (separados por vírgula)",
  "reports.filters.status": "Status",
  "reports.filters.statusPlaceholder": "Selecione o status",
  "reports.filters.partnerName": "Parceiro",
  "reports.filters.partnerNamePlaceholder": "Selecione o parceiro",
  "reports.filters.clientName": "Nome do Cliente",
  "reports.filters.clientNamePlaceholder": "Digite o nome do cliente",
  "reports.filters.clientCpf": "CPF do Cliente",
  "reports.filters.clientCpfPlaceholder": "Digite o CPF do cliente",
  "reports.filters.startDate": "Data Inicial",
  "reports.filters.endDate": "Data Final",
  "reports.filters.minimumPrice": "Preço Mínimo (R$)",
  "reports.filters.minimumPricePlaceholder": "Digite o preço mínimo",
  "reports.filters.maximumPrice": "Preço Máximo (R$)",
  "reports.filters.maximumPricePlaceholder": "Digite o preço máximo",
  "reports.filters.apply": "Aplicar Filtros",
  "reports.filters.clear": "Limpar Filtros",
  "reports.filters.supplier": "Fornecedor / Seguradora",
  "reports.filters.supplierPlaceholder": "Selecione o fornecedor",
  "reports.filters.product": "Produto",
  "reports.filters.productPlaceholder": "Todos os produtos do fornecedor",
  "reports.table.productName": "Produto",
  "reports.table.productValue": "Valor do produto",
  "reports.export.button": "Exportar CSV",
  "reports.export.success": "Relatório exportado com sucesso",

  //reports pagination
  "reports.pagination.showing": "Exibindo",
  "reports.pagination.to": "até",
  "reports.pagination.of": "de",
  "reports.pagination.results": "resultados",
  "reports.pagination.previous": "Anterior",
  "reports.pagination.next": "Próximo",

  //reports details modal
  "reports.details.title": "Detalhes da Venda",
  "reports.details.saleInfo": "Informações da Venda",
  "reports.details.clientInfo": "Dados do Cliente",
  "reports.details.planInfo": "Detalhes do Plano",
  "reports.details.fullName": "Nome Completo",
  "reports.details.email": "E-mail",
  "reports.details.cpf": "CPF",
  "reports.details.cellphone": "Celular",
  "reports.details.birthdate": "Data de Nascimento",
  "reports.details.gender": "Gênero",
  "reports.details.male": "Masculino",
  "reports.details.female": "Feminino",
  "reports.details.address": "Endereço",
  "reports.details.zipCode": "CEP",
  "reports.details.street": "Rua/Avenida",
  "reports.details.number": "Número",
  "reports.details.complement": "Complemento",
  "reports.details.district": "Bairro",
  "reports.details.city": "Cidade/Estado",
  "reports.details.planName": "Nome do Plano",
  "reports.details.planId": "ID do Plano",
  "reports.details.planDescription": "Descrição",
  "reports.details.products": "Produtos Inclusos no Plano",
  "reports.details.productName": "Nome do Produto",
  "reports.details.productDescription": "Descrição",
  "reports.details.productPrice": "Preço",
  "reports.details.total": "Total",

  //Error
  "errors.zipcodeNotFound": "CEP não encontrado ou inválido.",

  //knowledgeBase
  "knowledgeBase.form.title": "Base de Conhecimento",
  "knowledgeBase.form.description": "Gerencie a base de conhecimento do parceiro",
  "knowledgeBase.form.fields.name": "Nome da base de conhecimento",
  "knowledgeBase.form.fields.client": "Parceiro",
  "knowledgeBase.form.fields.files": "Arquivos",
  "knowledgeBase.form.placeholders.name": "Digite o nome da base de conhecimento",
  "knowledgeBase.form.placeholders.client": "Selecione o parceiro",
  "knowledgeBase.form.descriptions.files": "Selecione os arquivos para upload",
  "knowledgeBase.form.actions.selectFiles": "Selecionar arquivos",
  "knowledgeBase.form.actions.upload": "Enviar",
  "knowledgeBase.form.selectedFiles": "Arquivos selecionados",
  "knowledgeBase.success.filesUploaded": "Arquivos enviados com sucesso",

  //texts
  "texts.loading": "Carregando...",
};
